import { Controller } from "@hotwired/stimulus";

import { showToast } from "../lib/toast.js";

/** Кнопка «Поделиться»: кладёт адрес страницы в буфер обмена. */
export default class extends Controller {
  static values = { url: String };

  async copy() {
    const url = this.hasUrlValue ? this.urlValue : window.location.href;

    try {
      await navigator.clipboard.writeText(url);
      showToast("Ссылка скопирована", "success");
    } catch {
      // Буфер недоступен (нет разрешения или небезопасный контекст).
      showToast("Не удалось скопировать ссылку");
    }
  }
}
